import axios from "../utils/index";
import { encryptWithPublicKey } from "../utils/rsaEncrypt";
import {
  normalizeUploadPreviewUrl,
  normalizeUploadReference,
} from "../utils/uploadResponseUtils";

const api = {
  actInfo({ callback = (() => {}) as any }) {
    axios
      .get(`/v1/hospital/account/account-info-get`)
      .then((res) => {
        callback(res);
      })
      .catch((err) => {
        callback(err);
      });
  },
  getCurrentPassword({ params = {} as any, callback = (() => {}) as any }) {
    try {
      const encrypted = encryptWithPublicKey(params.key, params.password);
      axios
        .post(`/v1/hospital/account/account-password-get`, {
          password: encrypted,
        })
        .then((res) => {
          callback(res);
        })
        .catch((err) => {
          callback(err);
        });
    } catch (err: any) {
      callback({
        data: {
          code: 500,
          message: err?.message || "Unable to encrypt password",
        },
      });
    }
  },
  listApi({ params = {} as any, callback = (() => {}) as any }) {
    axios
      .get(
        `/v1/hospital/favourites/favourites-list/${params.page}/${params.pageSize}`,
      )
      .then((res) => {
        callback(res);
      })
      .catch((err) => {
        callback(err);
      });
  },
  uploadApi({ params = {} as any, callback = (() => {}) as any }) {
    axios
      .post(`/v1/public/upload/upload-file`, params)
      .then((res) => {
        if (res?.data?.data != null) {
          // Keep objectKey for persistence on callers that save res.data.data,
          // while preserving signedUrl under res.data.previewUrl for immediate UI.
          const raw = res.data.data;
          const objectKey = normalizeUploadReference(raw);
          const previewUrl = normalizeUploadPreviewUrl(raw);
          res.data.data = objectKey;
          res.data.previewUrl = previewUrl || objectKey;
        }
        callback(res);
      })
      .catch((err) => {
        callback(err);
      });
  },
  editApi({ params = {} as any, callback = (() => {}) as any }) {
    axios
      .put(`/v1/hospital/account/account-info-edit`, params)
      .then((res) => {
        callback(res);
      })
      .catch((err) => {
        callback(err);
      });
  },
  updateSkillLevelDisplayMode({
    mode = "CANONICAL" as "CANONICAL" | "SIMPLIFIED",
    callback = (() => {}) as any,
  }) {
    axios
      .put(`/v1/hospital/account/skill-level-display-mode/${mode}`)
      .then((res) => {
        callback(res);
      })
      .catch((err) => {
        callback(err);
      });
  },
  updateSkillLevelNamingState({
    state = "DEFAULT" as string,
    callback = (() => {}) as any,
  }) {
    axios
      .put(`/v1/hospital/account/skill-level-naming-state/${state}`)
      .then((res) => {
        callback(res);
      })
      .catch((err) => {
        callback(err);
      });
  },
  getSkillLevelNamingReference({ callback = (() => {}) as any }) {
    axios
      .get(`/v1/hospital/account/skill-level-naming-reference`)
      .then((res) => {
        callback(res);
      })
      .catch((err) => {
        callback(err);
      });
  },
  getHospitalMasterParent({
    hospitalName = "" as string,
    callback = (() => {}) as any,
  }) {
    axios
      .get(`/v1/admin/hospital-master/parent/${hospitalName}`)
      .then((res) => {
        callback(res);
      })
      .catch((err) => {
        callback(err);
      });
  },
  tokenGenerator({ accountId = "" as string, callback = (() => {}) as any }) {
    const loginToken =
      localStorage.getItem("master-token") ||
      localStorage.getItem("token-name") ||
      "";
    axios
      .get(`/v1/hospital/account/account-token-generator/${accountId}`, {
        headers: {
          "doctor-admin-token": loginToken,
        },
      })
      .then((res) => {
        callback(res);
      })
      .catch((err) => {
        callback(err);
      });
  },
  // Ratings and Reviews APIs
  // These v1 endpoints have been deprecated and replaced by newer v2 equivalents
  // (e.g., apiGetHospitalRatingsHistory, apiGetPendingRatings in rating.ts).
  // Methods temporarily disabled to clean up profile network calls.
  getHospitalRatings({ callback = (() => {}) as any }) {
    // Disabled
    callback({ data: { code: 200, data: {} } });
  },
  getHospitalReviews({ params = {} as any, callback = (() => {}) as any }) {
    // Disabled
    callback({ data: { code: 200, data: { list: [] } } });
  },
  getPendingRatings({ params = {} as any, callback = (() => {}) as any }) {
    // Disabled
    callback({ data: { code: 200, data: { list: [] } } });
  },
  submitDoctorRating({ params = {} as any, callback = (() => {}) as any }) {
    // Disabled
    callback({ data: { code: 200 } });
  },
};

export default api;
